import styled from "@emotion/styled";
import { Button, DatePicker, Input, Space } from "antd";
import dayjs from "dayjs";
import { FC, SetStateAction, useEffect, useState } from "react";

interface SearchProductFormProps {
    searchInput: string;
    setSearchInput:  (value: SetStateAction<string>) => void;
    /** แถบเครื่องมือคลัง — ช่องค้นหาแคบ ไม่ดันตัวกรองขึ้นบรรทัดใหม่ */
    compact?: boolean;
    placeholder?: string;
}

const SearchProductForm:FC<SearchProductFormProps> = (
{ 
searchInput,
setSearchInput,
compact = false,
placeholder = "ค้นหาชื่อสินค้า",
}) => { 
    const [tempSearchInput, setTempSearchInput] = useState<string>(searchInput);

    useEffect(()=> {
        setTempSearchInput(searchInput);
    }, [searchInput])

    const handleSearch = () => {
        setSearchInput(tempSearchInput);
    };
    
    const handleClear = () => {
        setTempSearchInput('');
        setSearchInput('');
    };  

    return (
    <ButtonWrapper $compact={compact}>
        <Space.Compact>
        <Input
            style={{
              height: '32px',
              width: compact ? 132 : undefined,
              flex: compact ? '0 0 132px' : undefined,
            }}
            placeholder={placeholder}
            value={tempSearchInput}
            onChange={(e) => setTempSearchInput(e.target.value)}
        />
        <Button type="default" onClick={handleSearch}>ค้นหา</Button>
        {(tempSearchInput) && (
            <Button type="default" onClick={handleClear}>X</Button>
        )}
        </Space.Compact>
      </ButtonWrapper>
    )
}

export default SearchProductForm;

const ButtonWrapper = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: row;
  width: ${({ $compact }) => ($compact ? "auto" : "100%")};
  height: 100%;
  margin: ${({ $compact }) => ($compact ? "0" : "0 0 10px 0")};
  flex-shrink: 0;
`;